Ext.define('SA.ChartLegendSummaryProperty', {
    alias: 'widget.chart-legend-summary-property',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-chart-legend-summary-property',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-chart-legend-summary-property-name',
                html: this.name
            }, {
                xtype: 'component',
                cls: 'sa-chart-legend-summary-property-value',
                itemId: 'value'
            }
        ];

        this.callParent();

        this.valueComponent = this.down('#value');
    },

    onBoxReady() {
        this.callParent(arguments);

        this.setValue(this.value);
    },

    setValue(value) {
        this.valueComponent.update(Ext.String.htmlEncode(value) || '&nbsp;'); 
    }
});